import React from 'react';

import type { Section, SmokingPolicySection } from '../../../models';
import SmokingPolicy from './SmokingPolicy';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: SmokingPolicySection) => void;
};

export default function SmokingPolicy_v5(props: Props): JSX.Element {
  return <SmokingPolicy {...props} outsideTextOverride="Outside, more than 15 feet from building" />;
}
